import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "./motionPresets";

const METRICS = [
  { value: "7", label: "branches on one ERP" },
  { value: "1,200+", label: "employees managed daily" },
  { value: "8 yrs", label: "running without interruption" },
];

const CaseStudyHighlight = () => (
  <section className="section">
    <motion.div
      className="case-study"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className="case-study__body">
        <p className="eyebrow">Customer story</p>
        <h2>
          Tightwell Fasteners runs all seven branches on Byteflow ERP — for
          eight years and counting
        </h2>
        <p>
          The Rohtak-based fastener manufacturer has trusted Byteflow
          Enterprise for 8 years — running manufacturing, inventory, payroll,
          and dispatch for 1,200+ employees across seven branches, every
          single day.
        </p>
        <blockquote className="case-study__quote">
          "At our scale — seven branches and twelve hundred people — the ERP
          just has to work. Byteflow has run smooth for eight years."
          <footer>— Operations Head, Tightwell Fasteners, Rohtak</footer>
        </blockquote>
        <Link to="/clients" className="btn-secondary">
          Read more customer stories →
        </Link>
      </div>
      <div className="case-study__metrics">
        {METRICS.map((m) => (
          <div key={m.label} className="case-study__metric">
            <span className="case-study__metric-value">{m.value}</span>
            <span className="case-study__metric-label">{m.label}</span>
          </div>
        ))}
      </div>
    </motion.div>
  </section>
);

export default CaseStudyHighlight;
